import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { connectToIntegration } from "./schema/connect-to-integration";
import { getAvailableIntegrations } from "./schema/get-available-integrations";

export const rpcDefinition = { getAvailableIntegrations, connectToIntegration };

export type RedoIntegrationsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
